import { yup } from "@swa-ui/object";

export const OTHER_ASSISTANCE_SCHEMA_FIELD_NAMES = {
  PEANUT_ALLERGY: "passengerDisabilityPeanut",
  PORTABLE_OXYGEN_CONCENTRATOR: "passengerDisabilityOxygen",
};

export const getOtherAssistanceFormFieldsSchema = (fieldNames = {}) => {
  const { PEANUT_ALLERGY, PORTABLE_OXYGEN_CONCENTRATOR } = OTHER_ASSISTANCE_SCHEMA_FIELD_NAMES;
  const {
    peanutAllergy = PEANUT_ALLERGY,
    portableOxygenConcentrator = PORTABLE_OXYGEN_CONCENTRATOR,
  } = fieldNames;

  return {
    [peanutAllergy]: yup.boolean(),
    [portableOxygenConcentrator]: yup.boolean(),
  };
};
